import { Title, Description } from "../../../../common"
import { QrCode, InfoConnection, LoadImage, ConnectionLink } from "./style"
export interface SessionQrcodeUiProps {
    qrcode: string;
    link?: string;
    load: boolean;
}

export const SessionQrcode: React.FC<SessionQrcodeUiProps> = ({ qrcode, link, load }) => {
    return (
        <>
            <Title>Conexão</Title>
            {!load &&
                <>
                    <Description align="center">
                        Escaneie este QR Code no dispositivo que<br />
                        exibirá os estímulos para iniciar a sessão.
                    </Description>

                    <QrCode src={qrcode} alt="QR Code" />
                    {link?.trim() && (
                        <ConnectionLink
                            href={link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Abrir link de conexão
                        </ConnectionLink>
                    )}
                    <InfoConnection>
                        <LoadImage src="/assets/images/load-gif2.gif" alt="Loading" />
                        Aguardando conexão do monitor…
                    </InfoConnection>
                </>
            }
        </>
    )
}